module.exports = require("./ro-MD.d.ts");